<script>
import { defineComponent } from 'vue';
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Login',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
    setup() {
        useMeta(metaData);
    },
    name: 'login',
    data() {
        return {
            u: "",
            p: "",
            c: "",
            rememberMe: false,
            validateReq: false
        }
    },
    methods: {
        onReset () {
            this.u = "";
            this.p = "";
            this.c = "";
            this.validateReq = false;
        },
        login() {
            this.$store.dispatch('auth/login', [this.u, this.p]);
        },
        verify() {
            this.$store.dispatch('auth/verify2FACode', this.c);
        }
    },
    computed: {
        isValid() {
            return (this.u.length>2 && this.p.length>2 ? true : false);
        },
        displayVerifyCode() {
            return this.$store.getters['auth/displayVerifyCode'];
        },
        isLoggedIn() {
            return this.$store.getters['auth/isLoggedIn'];
        }
    },
    watch: {
        isLoggedIn() {
            if (this.isLoggedIn) {
                this.$router.push('/');
            }
        }
    },
    created() {
        if (this.isLoggedIn) {
            this.$router.push('/');
        }
    }
})

</script>

<template>
<q-layout>

  <q-page-container>
    <div class="bodyContainer q-mt-lg q-gutter-xs" v-if="!displayVerifyCode">
        <div class="row mb-3">
            <div class="col-12">
                <a href="javascript:;" @click="$router.push('/')">
                    <img class="mb-4 imgFull" src="@/assets/images/wcwLogoBLACK.png" />
                </a>
                <h2 class="text-center mb-3">Welcome back, please sign in.</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form>
                    <div class="loginInput q-mb-lg">
                        <span class="loginInputButton"><i class="fa-lg fas fa-user"></i></span>
                        <input type="text" placeholder="Username" v-model.trim="u">
                    </div>
                    <br/>
                    <div class="loginInput q-mt-md">
                        <span class="loginInputButton"><i class="fa-lg fas fa-lock"></i></span>
                        <input type="password" placeholder="Password" v-model.trim="p">
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <span class="float-left">
                    <q-toggle v-model="rememberMe" label="Remember Me" />
                </span>
            </div>
            <div class="col-6">
                <span class="float-right">
                    <q-btn flat color="grey-13" label="Forgot Password?" @click="onReset(), $router.push('/forgot-password')"/>
                </span>
            </div>
        </div>
        <div class="row q-mt-md">
                <div class="col-4"></div>

                <div class="col-4 text-center">
                    <q-btn :ripple="{ color: 'blue' }" padding="7px 30px 7px 30px" squared class="bgWCWYellow" label="Login" style="border: 1px solid #666" @click="login()" :disabled="!isValid"/>
                </div>

                <div class="col-4"></div>
        </div>
        <div class="row">
            <div class="col-12 q-mt-lg">
                <p class="loginRegister mt-3">Don't have an account? <router-link :to="'/register'">Register</router-link></p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 q-mt-xl">
                <p class="loginRegister mt-3"><router-link :to="'/terms-of-service'">Terms of Service</router-link></p>
                <p class="loginRegister mt-3"><router-link :to="'/license-agreement'">License Agreement</router-link></p>
            </div>
        </div>
    </div>
    <div class="bodyContainer q-mt-lg q-gutter-xs" v-else>
        <div class="row mb-3">
            <div class="col-12">
                <img class="mb-4 imgFull" src="@/assets/images/wcwLogoBLACK.png" />
                <h2 class="text-center q-mt-sm">New Device Registration</h2>
                <h3 class="text-center">Check your email for Verification code</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form>
                    <div class="loginInput q-mb-lg">
                        <span class="loginInputButton"><i class="fa-lg fas fa-exclamation"></i></span>
                        <input type="text" placeholder="Verification Code" v-model.trim="c" autocomplete="off">
                    </div>
                </form>

            </div>
        </div>
        <div class="row q-mt-md">
                <div class="col-4"></div>

                <div class="col-4 text-center">
                    <q-btn :ripple="{ color: 'cyan-7' }" padding="7px 30px 7px 30px" squared class="bgWCWYellow" label="Verify" style="border: 1px solid #666" @click="verify()" :disabled="c.length<5"/>
                </div>

                <div class="col-4"></div>
        </div>
    </div>
  </q-page-container>

</q-layout>
</template>

